import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, renderSlot as _renderSlot, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-3a666b48"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled"]


export default /*#__PURE__*/_defineComponent({
  __name: 'Button',
  props: {
    label: {},
    primary: { type: Boolean },
    secondary: { type: Boolean },
    outline: { type: Boolean },
    disabled: { type: Boolean },
    onClick: { type: Function }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: _ctx.disabled,
    class: _normalizeClass(["button", { primary: _ctx.primary, secondary: _ctx.secondary, outline: _ctx.outline }]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
  }, [
    _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
    _renderSlot(_ctx.$slots, "default")
  ], 10, _hoisted_1))
}
}

})